export default "__VITE_ASSET__CAk7$BOn__"